import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createRoot, hydrateRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import { ResponsiveGrid } from "@adobe/aem-react-editable-components";
import { AuthoringUtils, Constants } from "@adobe/aem-spa-page-model-manager";
import { DataLayerComponent, Layout, PageRunner } from "@jti/loyalty";
import "@jti/loyalty/src/styles/base.scss";
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false,
        },
    },
});
function render(pageModel, useHydrate) {
    const container = document.getElementById("react-root");
    const isInEditor = AuthoringUtils.isInEditor();
    if (!container) {
        return null;
    }
    const attribute = container.getAttribute("data-layout") || "general";
    const jsx = (_jsx(QueryClientProvider, { client: queryClient, children: _jsxs(DataLayerComponent, { children: [_jsx(PageRunner, { name: attribute, isInEditor: isInEditor }), _jsx(Layout, { name: attribute, isInEditor: isInEditor, children: _jsx(ResponsiveGrid
                    //@ts-expect-error property not available in RespectiveGrid type
                    , { 
                        //@ts-expect-error property not available in RespectiveGrid type
                        pagePath: pageModel[Constants.PATH_PROP], isInEditor: isInEditor, itemPath: "root/responsivegrid" }) })] }) }));
    if (useHydrate) {
        hydrateRoot(container, jsx);
    }
    else {
        const root = createRoot(container);
        root.render(jsx);
    }
}
export default render;
